import { useMusicEngineInternal } from './MusicEngineContext';

export const useMusicEngine = () => {
  return useMusicEngineInternal();
};
